// extracted by mini-css-extract-plugin
export default {"aggregatedData":"PlayerBattedBallWRCPlusTable_aggregatedData__feeAE","clickable":"PlayerBattedBallWRCPlusTable_clickable__nqtv8"};